var Router = ReactRouter;
var Route = Router.Route;
var DefaultRoute = Router.DefaultRoute;
var Application = require('components/Application');
var BrocNote = require('components/BrocNote');

var routes = (
	React.createElement(Route, {name: "app", path: "/", handler: Application}, 
		React.createElement(DefaultRoute, {handler: BrocNote})
	)
);


module.exports = routes;